/**
 * ! Tokens Library
 * * AslanSN - 22-07-02
 */
export const Tokens = {
  Text: {
    Size: {
      buttons: "calc(0.1rem + 1.3vmin)",
      p: "calc(0.1rem + 1.8vmin);",
    },
    Color: {
      p: "#7C7C7C",
      Button: {
        white: "#fff",
        blue: "#324bff",
      },
    },
  },
  Background: {
    white: "#fff",
    lightBlue: "rgba(177, 213, 240, 0.5)",
    blue: "#324bff",
    darkBlue: "#003399",
    mediumGrey: "#CCCCCC",
    paleGrey: "#F7F7F7",
  },
  Padding: {
    button: "1vmin 2vmin 1vmin 2vmin",
  },
  Height: {
    button: "5vmin",
  },
  Width: {
    button: "8vmax",
  },
};
